module.exports = __webpack_public_path__ + "8a7b29dc7b190a69df148d71186c8b29.svg";